import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from 'react';
import { ArrowDown } from '@finect/tabular-icons/arrowDown';
import { rangeFromTo } from '@finect/front-utils/range';
import { getProductTypeLabel, getFundsListPath } from '@finect/front-resources/Products';
import { withTheme } from 'styled-components';
import { Helmet } from 'react-helmet-async';
import { Card, Cards } from '../../Grid';
import { ContentProductsGrid } from '../../Products/ContentProductsGrid';
import { ProductsTable } from '../../Products';
import { SkeletonSquare } from '../../Skeleton';
import { LoadMore } from '../../Loading';
import { Inner } from './partials';
import { breakpoints } from './breakpoints';
var getQueryStringFromFilters = function getQueryStringFromFilters(filters) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var params = {};
  if (filters.category.length) params.category = filters.category.join(',');
  if (filters.company.length) params.company = filters.company.join(',');
  if (filters.srri.length) params.srri = filters.srri.join(',');
  if (filters.country.length) params.country = filters.country.join(',');
  if (filters.order) params.order = filters.order;
  if (page > 1) params.page = page;
  return params;
};
var tableColumns = ['name', 'managementCompany', 'category', {
  id: 'performance',
  period: 'M12',
  type: 'accumulated'
}, {
  id: 'performance',
  period: 'M60',
  type: 'annualized'
}, 'performanceBars'];
var lastTableColumn = ['likeAction'];
var tableColumnsByOrderParam = [{
  id: 'performance',
  period: 'M0',
  type: 'accumulated'
}, {
  id: 'performance',
  period: 'M12',
  type: 'accumulated'
}, {
  id: 'performance',
  period: 'M24'
}, {
  id: 'performance',
  period: 'M36'
}, {
  id: 'performance',
  period: 'M60',
  type: 'annualized'
}, {
  id: 'performance',
  period: 'M120'
}].concat(_toConsumableArray(rangeFromTo(new Date().getFullYear() - 5, new Date().getFullYear() - 1).map(function (year) {
  return {
    id: 'yearlyPerformance',
    period: "".concat(year),
    year: year
  };
})), ['totalNetAsset']);
var FundsScreenerList = function FundsScreenerList(_ref) {
  var theme = _ref.theme,
    filters = _ref.filters,
    productType = _ref.productType,
    funds = _ref.funds,
    fetching = _ref.fetching,
    fetchingSkeletonItems = _ref.fetchingSkeletonItems,
    page = _ref.page,
    paging = _ref.paging,
    onLoadMoreClick = _ref.onLoadMoreClick,
    view = _ref.view,
    comparisonActions = _ref.comparisonActions,
    selectedProducts = _ref.selectedProducts,
    selectedProductsType = _ref.selectedProductsType,
    subscriptionsActions = _ref.subscriptionsActions,
    subscriptionsProps = _ref.subscriptionsProps;
  var handleLoadMoreClick = onLoadMoreClick ? onLoadMoreClick : function () {};
  var nextParams = getQueryStringFromFilters(filters, page + 1);
  var nextPath = getFundsListPath(theme, productType, nextParams);
  var prevParams = getQueryStringFromFilters(filters, page - 1);
  var prevPath = getFundsListPath(theme, productType, prevParams);
  var paginationReady = paging.hasOwnProperty('totalItems');
  var totalItems = paging.totalItems,
    limit = paging.limit;
  var pages = Math.ceil(totalItems / limit);
  var isLastPage = page === pages;
  var orderColumn = filters.order ? tableColumnsByOrderParam.find(function (item) {
    return item === filters.order.slice(1) || item.period === filters.order.slice(1);
  }) : null;
  var tableColumnsWithOrder = [].concat(tableColumns, _toConsumableArray(orderColumn && !tableColumns.find(function (item) {
    return JSON.stringify(item) === JSON.stringify(orderColumn);
  }) ? [orderColumn] : []), lastTableColumn);
  return React.createElement(Inner, null, paginationReady ? React.createElement(Helmet, null, page > 1 ? React.createElement("link", {
    rel: "prev",
    href: prevPath
  }) : null, pages > page ? React.createElement("link", {
    rel: "next",
    href: nextPath
  }) : null) : null, fetching && page === 1 ? React.createElement(React.Fragment, null, view === 'table' ? React.createElement(ProductsTable, {
    fetching: true,
    fetchingSkeletonItems: fetchingSkeletonItems,
    productType: productType,
    fields: tableColumnsWithOrder,
    size: "small",
    selectable: {
      initial: true,
      mode: 'comparison'
    }
  }) : null, view === 'grid' ? React.createElement(Cards, {
    breakpoints: breakpoints
  }, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (placeholderId) {
    return React.createElement(Card, {
      key: placeholderId
    }, React.createElement(SkeletonSquare, null));
  })) : null) : React.createElement(React.Fragment, null, view === 'table' ? React.createElement(ProductsTable, {
    actions: {
      onProductSubscription: subscriptionsActions.onAction
    },
    productsSubscriptions: subscriptionsProps.subscriptions.products,
    withCustomization: true,
    fetching: fetching,
    fetchingSkeletonItems: fetchingSkeletonItems,
    size: "small",
    products: funds.map(function (item) {
      return {
        entity: item,
        subtype: productType.apiSubtype
      };
    }),
    fields: tableColumnsWithOrder,
    selectable: {
      initial: true,
      mode: 'comparison'
    },
    onProductSelect: comparisonActions.setDrawerProductSelected,
    selectedProducts: selectedProducts,
    selectedProductsType: selectedProductsType
  }) : null, view === 'grid' ? React.createElement(ContentProductsGrid, {
    withSPA: true,
    fetching: false,
    fetched: true,
    products: funds.map(function (item) {
      return {
        entity: item,
        subtype: productType.apiSubtype
      };
    }),
    onFollow: function onFollow(product, status) {
      return subscriptionsActions.onAction('product', 'subscribe', product, status);
    },
    variant: "large",
    justify: "center",
    fixedWidth: "310px",
    subscriptions: subscriptionsProps.subscriptions.products
  }) : null), paginationReady ? React.createElement("div", null, isLastPage ? React.createElement(LoadMore, {
    light: true,
    disabled: true,
    loading: false
  }, "Has llegado al final") : null, page < pages ? React.createElement(LoadMore, {
    onClick: handleLoadMoreClick,
    loading: fetching,
    rel: "next"
  }, "Ver ", paging.totalItems - page * limit, " ", getProductTypeLabel(productType, 'plural', 'lowercase'), " m\xE1s", React.createElement(ArrowDown, {
    size: 16
  })) : null) : null);
};
export default withTheme(FundsScreenerList);